import { render } from "@testing-library/react";
import react, { Component } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Details from "./form/Details";
import Mainpage from "./Mainpage";
import posterOutput from "./output/PosterDisplay";

class App extends Component {
  render() {
    return (
      <>
        <BrowserRouter basename="/course-launch-poster">
          <Switch>
            <Route path="/" component={Mainpage} exact />
            <Route path="/details" component={Details} exact />

            <Route path="/posterOutput" component={posterOutput} exact />
          </Switch>
        </BrowserRouter>
      </>
    );
  }
}

export default App;
